import {
  HIDE_TOAST,
  SHOW_TOAST
} from '../actions/types'

export const showToast = (toastMessage, toastColor) => dispatch => {
  dispatch({
    type: SHOW_TOAST,
    payload: {
      toastMessage,
      toastColor
    }
  })

  setTimeout(() => {
    console.log('timeout')
    dispatch({ type: HIDE_TOAST })
  }, 5000)
}



// WEBPACK FOOTER //
// ./src/actions/toastActions.js